import { CABIN_CLASS } from './constant';
import { cabinClassOptionsPriority } from './variousOptionsProvider';

const disableOptionsByPriority = (field, options, currentOption) => {
  if (field !== CABIN_CLASS) {
    return options;
  }

  const priority = cabinClassOptionsPriority[currentOption];

  return options.map(option => {
    if (cabinClassOptionsPriority[option.value] < priority) {
      return { ...option, isDisabled: true };
    }

    return option;
  });
};

export default disableOptionsByPriority;
